<template>
  <v-card>
    <v-card-text>
      <div>
        <v-row class="mb-3">
          <v-col>
            <b>Выберите период:</b>
          </v-col>
          <v-col>
            <a-input-table-search-date v-model="datePeriod" />
          </v-col>
          <v-col>
            <v-btn color="primary" @click="fitchData()">Обновить</v-btn>
          </v-col>
        </v-row>
        <v-divider />
        <v-row>
          <v-col>
            <v-simple-table>
              <tbody>
                <tr v-for="(item, i) in items" :key="i">
                  <td>{{ item.title }}</td>
                  <td>{{ data[item.name] ? data[item.name] : "" }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row class="mb-3">
          <v-col>
            <b>Получения данных по оплатам:</b>
          </v-col>
          <v-col>
            <a-input-table-search-date v-model="payDatePeriod" />
          </v-col>
          <v-col>
            <v-btn color="primary" @click="genPayReport()">Сформировать</v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>


<script>
export default {
  components: {},
  data() {
    return {
      datePeriod: "",
      payDatePeriod: "",
      data: {},
      items: [
        { name: "workingDays", title: "Рабочих дней" },
        { name: "calls", title: "Звонки" },
        { name: "speakingCalls", title: "Разговоры" },
        { name: "callsCount", title: "% дозвона" },
        { name: "statusesAgree", title: "Согласен" },
        { name: "statusesNotAnswer", title: "Недозвон" },
        { name: "statusesDisagree", title: "Отказ" },
        { name: "statusesRecall", title: "Перезвонить" },
        { name: "speakingPerDay", title: "Разговоров в день" },
        { name: "callsPerDay", title: "Звонков в день" },
        { name: "promoCount", title: "Промокоды" },
        { name: "payCount", title: "Оплат" },
      ],
      title: "Статистика",
    };
  },
  watch: {
    datePeriod() {
      this.fitchData();
    },
  },
  created() {
    document.title = this.title;
    let today = new Date();
    // this.datePeriod = today.addDays(-7).date + " - " + today.date;
  },
  methods: {
    async fitchData() {
      try {
        let r = await this.$axios.p(this.$root.api.baseUrl + "statistic", {
          datePeriod: this.datePeriod,
        });
        this.data = r.data.data;
      } catch (error) {
        this.$root.$emit("show-info", {
          text: "ОШИБКА",
        });
      }
    },
    async genPayReport() {
      try {
        let r = await this.$axios.p(this.$root.api.baseUrl + "statistic/pays", {
          datePeriod: this.payDatePeriod,
        });
        this.$root.$emit("show-info", {
          text: "Запущена генерация отчета",
        });
      } catch (error) {
        this.$root.$emit("show-info", {
          text: "ОШИБКА",
        });
      }
    }
  },
};
</script>